import { Fragment } from 'react';
import { Link } from 'react-router-dom';

/**
 * v2 breadcrumb: `.link` items separated by "/", the current item in ink.
 * Collapses to "…" past five levels, keeping the root and the last two.
 */
export default function Breadcrumbs({ items = [], to = (item) => (item.id ? `/documents/${item.id}` : '/documents'), onNavigate }) {
  if (!items.length) return null;

  let visible = items;
  let collapsed = false;
  if (items.length > 5) {
    visible = [items[0], ...items.slice(-2)];
    collapsed = true;
  }

  const crumb = (item, isLast) => {
    if (isLast) {
      return (
        <span className="is-current" aria-current="page">
          {item.name}
        </span>
      );
    }
    if (onNavigate) {
      return (
        <button type="button" className="link" onClick={() => onNavigate(item)}>
          {item.name}
        </button>
      );
    }
    return (
      <Link className="link" to={to(item)}>
        {item.name}
      </Link>
    );
  };

  return (
    <nav className="crumbs" aria-label="Breadcrumb">
      {visible.map((item, i) => {
        const isLast = i === visible.length - 1;
        // Position-based key: callers use `null`, 'root' and 'self' as sentinel ids, which
        // must not collide with each other.
        return (
          <Fragment key={`${i}-${item.id ?? 'home'}`}>
            {i > 0 && <span className="muted">/</span>}
            {crumb(item, isLast)}
            {collapsed && i === 0 && (
              <>
                <span className="muted">/</span>
                <span className="muted" title={items.slice(1, -2).map((c) => c.name).join(' / ')}>
                  …
                </span>
              </>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
